import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { fromPlainText } from '@wix/da-editor-tiptap/pkg/components/utils/helpers';
import { UnsavedQuestion } from '../types';

export function useDefaultQuestions() {
  const { t } = useTranslation();
  return useMemo<UnsavedQuestion[]>(
    () => [
      {
        position: 0,
        question: fromPlainText(t('originalDeviationPopup.questionnaire.defaultQuestions.first')),
        type: 'free_text',
        isRequired: false,
      },
      {
        position: 1,
        question: fromPlainText(t('originalDeviationPopup.questionnaire.defaultQuestions.second')),
        type: 'free_text',
        isRequired: false,
      },
      {
        position: 2,
        question: fromPlainText(t('originalDeviationPopup.questionnaire.defaultQuestions.third')),
        type: 'single_choice',
        isRequired: true,
        answers: [
          {
            position: 0,
            answer: t('originalDeviationPopup.questionnaire.defaultQuestions.third.answer1'),
          },
          {
            position: 1,
            answer: t('originalDeviationPopup.questionnaire.defaultQuestions.third.answer2'),
          },
        ],
      },
    ],
    [t]
  );
}
